/* =============================================================
   BERTH BLOCKS — DATA ACCESS
   =============================================================
   `berth_blocks`: time a berth cannot be booked. A berth is open
   unless a block or a live booking overlaps the stay -- see
   supabase/migrations/20261004105501_create_berth_blocks.sql.

   `period` is a generated tstzrange, so it is never selected or
   written here; starts_at / ends_at are the editable pair.
   ============================================================= */

import { supabase } from './supabase'
import { toDataError } from './errors'
import type { BerthBlock, BerthBlockInput } from './types'

const COLUMNS = 'id, berth_id, starts_at, ends_at, reason'

export async function listBlocks(berthId: number): Promise<BerthBlock[]> {
  const { data, error } = await supabase
    .from('berth_blocks')
    .select(COLUMNS)
    .eq('berth_id', berthId)
    .order('starts_at', { ascending: true })

  if (error) throw toDataError(error, 'Could not load blocked time.')
  return (data ?? []) as BerthBlock[]
}

export async function createBlock(berthId: number, input: BerthBlockInput): Promise<BerthBlock> {
  const { data, error } = await supabase
    .from('berth_blocks')
    .insert({ berth_id: berthId, ...input })
    .select(COLUMNS)
    .single()

  if (error) throw toDataError(error, 'Could not add the block.')
  return data as BerthBlock
}

export async function deleteBlock(id: number): Promise<void> {
  const { error } = await supabase.from('berth_blocks').delete().eq('id', id)
  if (error) throw toDataError(error, 'Could not remove the block.')
}
